import { Component, EventEmitter, OnInit, output, Output } from '@angular/core';

import { Configuration, ConfigurationState } from 'remarketing-angular-library';
import { Subject } from 'rxjs';
import { select, Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { TranslocoDirective } from '@jsverse/transloco';
import { CheckIconComponent } from 'remarketing-ui-components-lib';

@Component({
  selector: 'app-mark-arrived-success-modal',
  imports: [TranslocoDirective, CheckIconComponent],
  templateUrl: './mark-arrived-success-modal.component.html',
  styleUrl: './mark-arrived-success-modal.component.scss'
})
export class MarkArrivedSuccessModalComponent {

  public readonly close = output();

  configuration$ = select(ConfigurationState.configuration);

  closeModal() {
    this.close.emit();
  }
}
